/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.1.0 (NJsonSchema v10.3.3.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class DashboardsApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<Dashboard[]> {
        let url_ = this.baseUrl + "/api/dashboards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<Dashboard[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dashboard.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dashboard[]>(<any>null);
    }
}

export class ClientAuthenticationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getJavaScriptClient(): Promise<JavaScriptClientDto> {
        let url_ = this.baseUrl + "/api/authentication/javascript-client";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetJavaScriptClient(_response);
        });
    }

    protected processGetJavaScriptClient(response: Response): Promise<JavaScriptClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JavaScriptClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JavaScriptClientDto>(<any>null);
    }
}

export class ClientAuthorisationApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    isAuthorised(policies: string[] | null | undefined): Promise<IsAuthorisedDto> {
        let url_ = this.baseUrl + "/api/authorisation/is-authorised?";
        if (policies !== undefined && policies !== null)
            policies && policies.forEach(item => { url_ += "policies=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAuthorised(_response);
        });
    }

    protected processIsAuthorised(response: Response): Promise<IsAuthorisedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsAuthorisedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsAuthorisedDto>(<any>null);
    }
}

export class AppInfoApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<AppInfo> {
        let url_ = this.baseUrl + "/api/appinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<AppInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppInfo>(<any>null);
    }

    get2(): Promise<AppInfo> {
        let url_ = this.baseUrl + "/_info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: Response): Promise<AppInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppInfo>(<any>null);
    }
}

export class Dashboard implements IDashboard {
    id!: string;
    name!: string;
    contentUrl!: string;
    category!: string;
    owner!: string;
    rank!: number;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.contentUrl = _data["contentUrl"];
            this.category = _data["category"];
            this.owner = _data["owner"];
            this.rank = _data["rank"];
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["contentUrl"] = this.contentUrl;
        data["category"] = this.category;
        data["owner"] = this.owner;
        data["rank"] = this.rank;
        return data; 
    }
}

export interface IDashboard {
    id: string;
    name: string;
    contentUrl: string;
    category: string;
    owner: string;
    rank: number;
}

export class JavaScriptClientDto implements IJavaScriptClientDto {
    authority!: string;
    clientId!: string;
    redirectUrl!: string;
    silentRedirectUrl!: string;
    responseType!: string;
    scope!: string;
    postLogoutRedirectUrl!: string;

    constructor(data?: IJavaScriptClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authority = _data["authority"];
            this.clientId = _data["clientId"];
            this.redirectUrl = _data["redirectUrl"];
            this.silentRedirectUrl = _data["silentRedirectUrl"];
            this.responseType = _data["responseType"];
            this.scope = _data["scope"];
            this.postLogoutRedirectUrl = _data["postLogoutRedirectUrl"];
        }
    }

    static fromJS(data: any): JavaScriptClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new JavaScriptClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["clientId"] = this.clientId;
        data["redirectUrl"] = this.redirectUrl;
        data["silentRedirectUrl"] = this.silentRedirectUrl;
        data["responseType"] = this.responseType;
        data["scope"] = this.scope;
        data["postLogoutRedirectUrl"] = this.postLogoutRedirectUrl;
        return data; 
    }
}

export interface IJavaScriptClientDto {
    authority: string;
    clientId: string;
    redirectUrl: string;
    silentRedirectUrl: string;
    responseType: string;
    scope: string;
    postLogoutRedirectUrl: string;
}

export class IsAuthorisedDto implements IIsAuthorisedDto {
    isAuthorised?: boolean;

    constructor(data?: IIsAuthorisedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthorised = _data["isAuthorised"];
        }
    }

    static fromJS(data: any): IsAuthorisedDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsAuthorisedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthorised"] = this.isAuthorised;
        return data; 
    }
}

export interface IIsAuthorisedDto {
    isAuthorised?: boolean;
}

export class AppInfo implements IAppInfo {
    buildDate!: string;
    startTime!: string;
    upTime!: string;
    version!: string;
    processId!: number;
    company!: string;
    product!: string;
    gitCommit!: string;
    framework!: string;
    configuration!: string;
    environmentName!: string;

    constructor(data?: IAppInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildDate = _data["buildDate"];
            this.startTime = _data["startTime"];
            this.upTime = _data["upTime"];
            this.version = _data["version"];
            this.processId = _data["processId"];
            this.company = _data["company"];
            this.product = _data["product"];
            this.gitCommit = _data["gitCommit"];
            this.framework = _data["framework"];
            this.configuration = _data["configuration"];
            this.environmentName = _data["environmentName"];
        }
    }

    static fromJS(data: any): AppInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildDate"] = this.buildDate;
        data["startTime"] = this.startTime;
        data["upTime"] = this.upTime;
        data["version"] = this.version;
        data["processId"] = this.processId;
        data["company"] = this.company;
        data["product"] = this.product;
        data["gitCommit"] = this.gitCommit;
        data["framework"] = this.framework;
        data["configuration"] = this.configuration;
        data["environmentName"] = this.environmentName;
        return data; 
    }
}

export interface IAppInfo {
    buildDate: string;
    startTime: string;
    upTime: string;
    version: string;
    processId: number;
    company: string;
    product: string;
    gitCommit: string;
    framework: string;
    configuration: string;
    environmentName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}